var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer__main-container"},[_c('div',[_vm._v(" User: "+_vm._s(_vm.user && _vm.user.userable ? _vm.user.userable.name : ''))]),_c('div',{staticClass:"date-info"},[_vm._v(" Date: "+_vm._s(_vm.$options.format(Date.now(), 'MM/dd/yyyy')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }